(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('TaskObjectTypeDialogController', TaskObjectTypeDialogController);

    TaskObjectTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaskObjectType'];

    function TaskObjectTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaskObjectType) {
        var vm = this;

        vm.taskObjectType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.taskObjectType.id !== null) {
                TaskObjectType.update(vm.taskObjectType, onSaveSuccess, onSaveError);
            } else {
                TaskObjectType.save(vm.taskObjectType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:taskObjectTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
